import { COLORS_KEYS, COLORS } from '@helpers/constant';
import { Typography, Marker } from '@ui/components';
import { useTranslation } from 'react-i18next';

export const ColorOptions = () => {
  const { t } = useTranslation();

  return COLORS_KEYS.map((color) => ({
    label: (
      <div className="flex gap-2">
        <Marker variant={COLORS[color]} className="size-4" border />
        <Typography variant="labelMediumBook" element="span">
          {t(`COLORS.${color}`)}
        </Typography>
      </div>
    ),
    value: COLORS[color],
  }));
};
